import { createContext, useContext, type ReactNode } from 'react';

const AppNavBreadcrumbsContext = createContext<ReactNode>(null);

/**
 * Hands the page's breadcrumb trail to the top navigation bar, which shows it
 * between the brand and the trailing actions. `AppLayout` provides it from its
 * `breadcrumbs` slot, so the trail is declared with the rest of the layout even
 * though the bar draws it.
 */
export function AppNavBreadcrumbsProvider({
  breadcrumbs,
  children,
}: {
  breadcrumbs: ReactNode;
  children: ReactNode;
}) {
  return (
    <AppNavBreadcrumbsContext.Provider value={breadcrumbs}>
      {children}
    </AppNavBreadcrumbsContext.Provider>
  );
}

/** The trail the enclosing `AppLayout` was given, or `null` when it has none. */
export function useAppNavBreadcrumbs(): ReactNode {
  return useContext(AppNavBreadcrumbsContext);
}
